const getPrivilegeList = () => {
  const privilege = JSON.parse(localStorage.getItem("privilege") || "{}");
  return {
    Login: !!privilege["32TMN5JG"],
    customerDetailsView: !!privilege["4XOZPPXG"],
    loanDetailsView: !!privilege["66NEFO0J"],
    disbursementDetailsView: !!privilege["5TC4NKON"],
    customerDocumentsView: !!privilege["B9O0PMVE"],
    addProductView: !!privilege["0AO9S7HI"],


    productTabView: !!privilege["H5V9VN0T"],
    creditTabView: !!privilege["THA21NFK"],
    employeeTabView: !!privilege["ZND65G0H"],
    todayEmiTabView: !!privilege["JS55B2XW"],
    overDewTabView: !!privilege["N0UEATFY"],
    customerTabView: !!privilege["AUIU0K08"],
    loanTabView: !!privilege["TV1M7XWP"],
    rejectTabView: !!privilege["PAJPALAG"],
    collectionTabView: !!privilege["E2VPNFMX"],
    disbursementTabView: !!privilege["3VJZ3DKS"],
    privilegeTabView: !!privilege["MJ7L3MGJ"],
    addEmployeeTabView: !!privilege["5VDYYIFJ"],
    paymentTabView: !!privilege["FFHF26Q8"],
    reportingTabView: !!privilege["Q8VWM6XT"],
    reportingProfileView: !!privilege["Q8VWM6XT"],
    payoutRequestTabView: !!privilege["JLQSXWYQ"],

    blockTabView: !!privilege["Q8W7616P"],
    breButtonView: !!privilege["R56ANDEQ"],
    breMasterToggleView: !!privilege["AQH8FRRS"],
    breFinanceToggleView: !!privilege["2OH3P0WC"],
    LoginTabView: !!privilege["564JW89Z"],
    appStatusView: !!privilege["MU23F1DV"],
    emiCalculateTabView: !!privilege["ZKIITIQV"],
    emiCalculatorNormalView: !!privilege["ZVYJ8J37"],
    emiCalculatorFinanceView: !!privilege["OBSMNEC3"],


    
    productEdit: privilege["WDU2QSMM"] === 2,
    employeeEdit: privilege["2KQGMEZO"] === 2,
    personalDetailsEdit: privilege["TT6L1YQR"] === 2,
    currentAddressEdit: privilege["L5CK7CNF"] === 2,
    permanenetAddressEdit: privilege["JREC9IAE"] === 2,
    referenceDetailsEdit: privilege["IENCF259"] === 2,
    professionalDetailsEdit: privilege["O91UNDIA"] === 2,
    bankDetailsEdit: privilege["WJ1TNNKX"] === 2,
    statusEdit: privilege["9V12O7ZU"] === 2,

    overdewActionColumn: !!privilege["NHTCRM0O"],
    uploadSalarySlip: !!privilege["R1XFXYPR"],
    breView: !!privilege["RFLZJLIP"],
    feesWaveOff: !!privilege["WEX560RU"],

    manualPaymentView: !!privilege["RMB4KZ19"],
    pfgstView: !!privilege["31HNQAS2"],
    overallCollectionReportView: !!privilege["GXHZEZBR"],
    pendingApprovalExportView: !!privilege["133IWQS7"],
    MandateRegistrationView: !!privilege["S5GX3UHE"],
    mandateNotificationView: !!privilege["3C4FJI4W"],
    mandateRevokeView: !!privilege["XBGV72K1"],


    // Caller Remarks View:-
    CallerTabView: !!privilege["DCRGU76F"],
    assignCasesView: !!privilege["Q1PWVT6J"],
    autoAssignCasesView: !!privilege["Q1PWVT6J"],
    callerReportView: !!privilege["PK57O7D5"],
    otherLspTabView: !!privilege["AQ6EO5BK"],
    otherLspUpload: !!privilege["XD6SRC3O"],

    //Finance
    companyTabView: !!privilege["NGGT9U78"],
    companyEdit: privilege["C1P0IZE2"] === 2,
    companyAdd: privilege["RDH841PM"] === 2,

    branchTabView: !!privilege["PQGTUQ7S"],
    branchEdit: privilege["41ULU1F0"] === 2,
    branchAdd: privilege["9BNH910Q"] === 2,

    agentTabView: !!privilege["FCUZH2Y8"],
    agentEdit: privilege["7QHM383I"] === 2,
    agentAdd: privilege["BYFF3T9Q"] === 2,

    walletTabView: privilege["E8BGZC37"],
    walletTransactionView: !!privilege["YPGYHVEQ"],

    // Credit Underwriting block privileges
    pedayBreView: !!privilege["99YVJZFX"],
    agentBreView: !!privilege["M7TLWB8L"],
    financeBreView: !!privilege["SENK4ZZT"],
    softApprovalView: !!privilege["T51TY1KG"]

  };
};

export default getPrivilegeList;

